export function range(min: number, max: number) {
  return Math.min(Math.max(0, min), max);
}
